export default __webpack_public_path__ + "static/media/aceclippi.5cf0512f.png";